"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _connectedReactRouter = require("connected-react-router");

var _default = function _default(history) {
  return (0, _connectedReactRouter.routerMiddleware)(history);
};

exports.default = _default;